import { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import pusher from './pusher';
import { addReadMessage, setUser, updateOnlineStatusFromConvList } from '../../redux/actions';
import { addOnlinePresence, removeOnlinePresence, setOnlinePresence } from '../../redux/actions/user';
import { templateSettings } from 'lodash';
import store from '../../redux/reducers/reducer';
import { ROLES } from './constants';

const useOnlineHook = (refetch = () => ({})) => {
    const dispatch = useDispatch();

    const user = useSelector(state => state.user.user);

    const [puChannelName, setPuChannelName] = useState('');
    const [puChannel, setPuChannel] = useState(null);
    const [userInformation, setUserInformation] = useState({});

    const handleOnline = data => {
        const userId = parseInt(data.user_id);
        dispatch(addOnlinePresence(userId));
        dispatch(updateOnlineStatusFromConvList({
            user: userId,
            status: true
        }));

        window.dispatchEvent(new CustomEvent('onlineHook/online', {
            detail: {
                user_id: userId
            }
        }));
    };

    const handleNewMessage = data => {
        const convList = store.getState().message.convList;
        const index = convList.findIndex(conv => conv.user_b == data.sender_id || conv.user_a == data.sender_id);
        if (index != 0) {
            refetch();
        }
    };

    const handleOfflineStatus = data => {
        const userId = data.user_id;
        dispatch(removeOnlinePresence(userId));
        dispatch(updateOnlineStatusFromConvList({
            user: userId,
            status: false
        }));
        window.dispatchEvent(new CustomEvent('onlineHook/offline', {
            detail: {
                user_id: userId
            }
        }));
    };

    const handleReadMessage = data => {
        dispatch(addReadMessage(data.message_id));
    };

    const handleOnlineStatus = response => {
        if (response.data.type === 'online') {
            handleOnline(response.data.data);
        }

        if (response.data.type === 'new_message') {
            handleNewMessage(response.data.data);
        }

        if (response.data.type === 'offline') {
            handleOfflineStatus(response.data.data);
        }

        if (response.data.type === 'read_message') {
            handleReadMessage(response.data.data);
        }

    };

    useEffect(() => {
        if (user && Object.keys(user).length <= 0) {
            dispatch(setUser());
        }

    }, []);

    useEffect(() => {
        setUserInformation(user);
    }, [user]);

    /**
     * enabled for pu for now
     */
    useEffect(() => {
        if (userInformation && Object.keys(userInformation).length > 0) {
            setPuChannelName(`private-online-${userInformation.id}`);
        }
    }, [userInformation]);

    useEffect(() => {
        if (puChannelName) {
            setPuChannel(pusher.subscribe(puChannelName));
        }

    }, [puChannelName]);

    useEffect(() => {
        if (puChannel) {
            puChannel.bind('App\\Events\\OnlineStatusEvent', d => {
                handleOnlineStatus(d);
            });
        }
    }, [puChannel]);
};

export default useOnlineHook;